import { Fragment, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    BottomNavigation,
    BottomNavigationAction,
    Dialog,
    DialogContent,
    DialogTitle,
    InputAdornment,
    Paper,
    TextField,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SearchIcon from '@mui/icons-material/Search';

export default function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [searchOpen, setSearchOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        setSearchOpen(false);
        setSearchValue('');
    }, [location.pathname]);

    if (!isSmallScreen || location.pathname === '/login' || location.pathname === '/signup') return null;

    const handleSearchSubmit = (e) => {
        if (e.key === 'Enter' && searchValue.trim()) {
            navigate(`/search/${encodeURIComponent(searchValue.trim())}`);
        }
    };

    return (
        <Fragment>
            <Dialog
                open={searchOpen}
                onClose={() => { setSearchOpen(false); setSearchValue(''); }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}><SearchIcon sx={{ color: 'primary.main' }} />Search Recipes</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        size="small"
                        placeholder="Search recipes…"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={handleSearchSubmit}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
            </Dialog>

            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000, borderRadius: 0 }} elevation={3}>
                <BottomNavigation showLabels>
                    <BottomNavigationAction label="Recipe Types" icon={<MenuBookIcon />} component={Link} to="/types" />
                    <BottomNavigationAction label="Home" icon={<HomeIcon />} component={Link} to="/" />
                    <BottomNavigationAction label="Search" icon={<SearchIcon />} onClick={() => setSearchOpen(true)} />
                </BottomNavigation>
            </Paper>
        </Fragment>
    );
}
